import React, { useState, useRef, useEffect, Fragment } from 'react'
import classNames from 'classnames'

import './styles.scss'

const ImageCropPreview = ({
  imageUrl,
  height,
  width,
  x,
  y,
  naturalHeight,
  naturalWidth,
  fitt = true,
  className,
  circularProp,
}) => {
  const ref = useRef(null)
  const [scale, setScale] = useState(1)
  const previewClassNames = classNames('image-preview', className)

  useEffect(() => {
    let currentScale = width / ref.current.clientWidth

    if (!fitt) {
      currentScale = currentScale > 1 ? currentScale : 1
    }

    setScale(currentScale)
  }, [width, imageUrl])

  return (
    <div ref={ref}>
      {!imageUrl && <Fragment />}
      {imageUrl && (
        <div
          className={previewClassNames}
          style={{
            backgroundImage: `url('${imageUrl}')`,
            width: width / scale,
            height: height / scale,
            backgroundPosition: `-${x / scale}px -${y / scale}px`,
            backgroundSize: `${naturalWidth / scale}px ${naturalHeight / scale}px`,
            backgroundRepeat: 'no-repeat',
            borderRadius: circularProp ? '50%' : 'unset',
          }}
        />
      )}
    </div>
  )
}

export default ImageCropPreview
